module.exports = __webpack_public_path__ + "assets/img/03.aae7a62b.png";